import { InputHTMLAttributes, useId } from 'react'

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  error?: string
  hint?: string
}

export function Input({ label, error, hint, className = '', id, ...props }: InputProps) {
  const generatedId = useId()
  const inputId = id || generatedId

  // If no label, render just the input element
  if (!label) {
    return (
      <input
        id={inputId}
        className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-tessan-green focus:border-transparent transition-colors ${
          error ? 'border-error' : 'border-gray-300'
        } ${className}`}
        {...props}
      />
    )
  }

  return (
    <div className="space-y-1">
      <label htmlFor={inputId} className="block text-sm font-medium text-text-primary">
        {label}
        {props.required && <span className="text-error ml-1">*</span>}
      </label>
      <input
        id={inputId}
        className={`w-full px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-tessan-green focus:border-transparent transition-colors ${
          error ? 'border-error' : 'border-gray-300'
        } ${className}`}
        {...props}
      />
      {hint && !error && (
        <p className="text-xs text-text-muted">{hint}</p>
      )}
      {error && (
        <p className="text-xs text-error">{error}</p>
      )}
    </div>
  )
}
